export function getPageCount(items, pageSize) {
  return items.length === 0 ? 1 : Math.ceil(items.length / pageSize);
}
export function getPagedItems(items, page, pageSize) {
  return items.slice((page - 1) * pageSize, page * pageSize);
}
export default {
  getPageCount: getPageCount,
  getPagedItems: getPagedItems
};